/// <reference path="../app/app.definition.ts" />

declare global {
    interface String {
        regexEscape(): string;
        interpolate(params: Record<string, any>): string;
        toCamelCase(): string;
    }
}
export const STORAGE_NAME: string = 'diagnosticsCampaign';
export const SOS = 'SOS';
export const R_URL = 'responseURL';
export const ON_UN = 'onunhandledrejection';
export const ON_P_UN = 'onpossiblyunhandledrejection';
export const ON_E = 'onerror';
export const XHR = 'XMLHttpRequest';
export const LOGIN_REGEX = /\/#\/ecare-vault\/login.*$/;
export const URL_REGEX = /^(http|https):\/\/(jeavio-dev|ecv-dev|dev|qa|qa2|qa-notifications|qa2-notifications|staging|staging-notifications|my|notifications)\.ecarevault\.com/;
export const OK_STATUS = /^(200|201|304)/;
export const DEBUG = 'debug';
export const MAN_DEBUG = 'manualdebug';
export const PROD = 'my'
export const PRINT_STACK = 'printStackTrace';
export const TEAMS_FILTER = 'filterTeamsBy';


export const DIAG = 'EcvDiagnosticsConf';
export const VEND = "ExcVendorConf"

export let debug: boolean;
export let my: boolean;
const eCareVault = window.eCareVault = window.eCareVault || {};

// clone function by Ian Tripp
export const clone = (original: any, deep?: boolean, maxDepth?: number, currentDepth?: number): any => {
    !currentDepth && (currentDepth = 0);
    deep = !!deep;

    switch (typeof original) {
        case 'object':
            let isArray: boolean = Array.isArray(original);
            let cloned: any = isArray ? [] : {};

            // If an array, clone each item, retaining order
            if (isArray) {
                for (let originalItem of original) {
                    cloned.push(deep ? clone(originalItem, deep, maxDepth, currentDepth + 1) : originalItem);
                }
            }

            // go through each property, add a true copy of its value
            // ignores numeric fields if it is an array
            for (let prop in original) {
                if (original.hasOwnProperty(prop) && (typeof prop == 'string' || !isArray)) {
                    let desc = Object.getOwnPropertyDescriptor(original, prop);

                    let clonedProperty = !!desc.get || !!desc.set ? {
                        get: desc.get, // can't clone the function so copy the reference
                        set: desc.set, // can't clone the function so copy the reference
                        configurable: desc.configurable,
                        enumerable: desc.enumerable
                    } : {
                        value: deep ? clone(original[prop], deep, maxDepth, currentDepth + 1) : original[prop],
                        writable: desc.writable,
                        configurable: desc.configurable,
                        enumerable: desc.enumerable
                    };

                    Object.defineProperty(cloned, prop, clonedProperty);
                }
            }

            //If not justa basic Object, make it the same class as the original
            let originalProto = Object.getPrototypeOf(original);
            if (originalProto !== Object.prototype) {
                Object.setPrototypeOf(cloned, originalProto);
            }

            return cloned;
        case 'string': //Primitives are never references
        case 'number':
        case 'boolean':
            return original;
        case 'undefined':
        default:
            return undefined;

    }
};


export function initializeGlobalConfigs(config: any) {
    Object.defineProperty(window, PROD, {value: config.ecareEnv == PROD, writable: false});
    Object.defineProperty(window, DEBUG, {
        get: () => {
            let active = window[MAN_DEBUG] != null ? window[MAN_DEBUG] : window[PROD] == false;
            return active;
        },
        set: (bool: any): void => {
            if (bool === true || bool === false) {
                if (!bool && window[DEBUG] === true) {
                    console.log("Turning off debugging");
                } else if (bool && window[DEBUG] === false) {
                    console.log("Turning on debugging");
                }
                window[MAN_DEBUG] = bool;
            }
        }
    });

    Object.defineProperty(eCareVault, TEAMS_FILTER, {
        value: {
            PROJECT_TEAM: {
                typeId: 2,
                typeName: 'Project Team',
                filterMapValue: 'PROJECT'
            },
            INDIVIDUAL_TEAM: {
                typeId: 1,
                typeName: 'Individual Care Team',
                filterMapValue: 'INDIVIDUAL'
            }
        },
        writable: false
    });

    Object.defineProperty(eCareVault, PROD, {get: (): boolean => window[PROD]});
    Object.defineProperty(eCareVault, DEBUG, {
        get: (): boolean => !!window[DEBUG],
        set: (bool: boolean): void => {
            if (bool === true || bool === false) {
                window[DEBUG] = bool;
            }
        }
    });
}

// Shims for missing javascript functionality

if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, 'includes', {
        value: function (search, start) {
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        }
    });
}

if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            const o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            const len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            const thisArg = arguments[1];

            // 5. Let k be 0.
            // 6. Repeat, while k < len
            for (let k =0; k < len; k++) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                const kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}

if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            const o = Object(this);
            const len = o.length >>> 0;
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            const thisArg = arguments[1];
            for (let k = 0; k < len; k++) {
                const kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
            }
            return -1;
        }
    });
}
;

if (!String.prototype.regexEscape) {
    Object.defineProperty(String.prototype, 'regexEscape', {
        value: function (s) {
            return this.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        }
    });
}

if (!String.prototype.interpolate) {
    Object.defineProperty(String.prototype, 'interpolate', {
        value: function (params) {
            if (isIE11) {
                let rtnStr = this;
                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const reg = new String('${' + key + '}').regexEscape();
                        rtnStr = rtnStr.replace(new RegExp(reg, 'g'), params[key]);
                    }
                }
                return rtnStr;
            } else {
                const names = Object.keys(params);
                const vals = Object.values(params);
                return new Function(...names, `return \`${this}\`;`)(...vals);
            }
        }
    });
}

if (!String.prototype.toCamelCase) {
    Object.defineProperty(String.prototype, 'toCamelCase', {
        value: function () {
            if (!!this) {
                return this.replace(/\s(.)/g, function (a) {
                    return a.toUpperCase();
                }).replace(/\s/g, '')
                    .replace(/^(.)/, function (b) {
                        return b.toLowerCase();
                    });
            } else {
                return "";
            }
        }
    });
}

